import { ClipboardCheck, Settings, HardHat, Smile } from "lucide-react";

const steps = [
  {
    icon: ClipboardCheck,
    num: "01",
    title: "Free Consultation",
    desc: "Our experts visit your home to assess your staircase and understand your mobility needs.",
  },
  {
    icon: Settings,
    num: "02",
    title: "Custom Build",
    desc: "Each stair lift is tailored to your stair layout for safety, comfort & seamless integration.",
  },
  {
    icon: HardHat,
    num: "03",
    title: "Professional Install",
    desc: "Certified technicians install your lift in 1-2 days with minimal disruption.",
  },
  {
    icon: Smile,
    num: "04",
    title: "Enjoy Safe Mobility",
    desc: "Smooth, quiet rides every day with advanced safety features & lifetime support.",
  },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" className="py-16 sm:py-20 bg-stone-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b22300] mb-3 text-center">Simple Process</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 text-center font-['Outfit']">
          How It Works
        </h2>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div key={s.num} data-testid={`step-card-${i}`} className="relative rounded-2xl border border-stone-200 bg-white p-6 text-center hover:shadow-md transition-shadow">
              <span className="absolute top-4 right-4 text-5xl font-bold text-stone-100 font-['Outfit'] select-none">{s.num}</span>
              <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center mx-auto mb-4 relative z-10">
                <s.icon className="w-6 h-6 text-[#b22300]" />
              </div>
              <h3 className="text-base font-semibold text-stone-900 font-['Outfit'] relative z-10">{s.title}</h3>
              <p className="text-stone-500 text-sm mt-2 leading-relaxed relative z-10">{s.desc}</p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 text-stone-300 text-xl z-20">&rarr;</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
